// extracted by mini-css-extract-plugin
module.exports = {"container":"NewsModale_container__3B0-l","col-2":"NewsModale_col-2__3mvGt","info":"NewsModale_info__1JXsV"};